export const FLEXIBLE_PROPERTIES_VIEW_MODE = {
  PROPERTIES: 'properties',
  UNITS: 'units',
  BOTH: 'both',
} as const;

export type FlexiblePropertiesViewMode =
  (typeof FLEXIBLE_PROPERTIES_VIEW_MODE)[keyof typeof FLEXIBLE_PROPERTIES_VIEW_MODE];

export const DEFAULT_FLEXIBLE_PROPERTIES_VIEW_MODE = FLEXIBLE_PROPERTIES_VIEW_MODE.PROPERTIES;
